import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Flex,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Typography,
} from "antd";
import country from "../common/country";
import { useSearchParams } from "react-router-dom";
import ContactInput from "../Components/ContactInput";
import logo from "../Assets/logo.webp";

import axios from "axios";
import IntlPhoneInput from "../Components/IntlPhoneInput";
function InquieryForm() {
  const [searchParams] = useSearchParams();
  const white_label = searchParams.get("wlid");
  const [form] = Form.useForm();
  const [countryCode, setCountryCode] = useState("auto");

  const [loading, setLoading] = useState({
    formLoading: false,
    otpLoading: false,
  });

  const onFinish = (val) => {
    setLoading({ ...loading, formLoading: true });
    axios
      .post(`${process.env.REACT_APP_ADMIN_API_URL}leads-enquiry/create`, {
        ...val,
        formType: "PIP_GRID",
      })
      .then((res) => {
        if (res?.data?.success) {
          message.success(res?.data?.message);
          form.resetFields();
        }
      })
      .catch((e) => {
        message.error(e.message);
      })
      .finally(() => {
        setLoading({ ...loading, formLoading: false });
      });
  };
  return (
    <>
      <div className="lead-container">
        <div className="lead-content">
          <div className="logo-wrapper">
            <img
              src={logo}
              // src={`${process.env.REACT_APP_API_URL}white-label/logo/${white_label}`}
              className="logo"
            />
          </div>
          <div className="lead-logo-wrapper">
            <p>
              Please fill in your details below to complete your registration.
            </p>
          </div>
        </div>
        <div className="lead-form-block">
          <div className="form-block">
            <Form
              name="lead"
              onFinish={onFinish}
              autoComplete="off"
              layout="vertical"
              form={form}
            >
              <Row gutter={20}>
                <Col span={24}>
                  <Form.Item label="I Want to Register as" name="register_as">
                    <Select
                      placeholder="Select a Option"
                      size="large"
                      options={[
                        { value: "Broker", label: "Broker" },
                        { value: "SD", label: "SD" },
                        { value: "RM", label: "RM" },
                        { value: "TL", label: "TL" },
                        { value: "BDM", label: "BDM" },
                        { value: "IB", label: "IB" },
                        { value: "Investor", label: "Investor" },
                        { value: "Trader", label: "Trader" },
                      ]}
                    />
                  </Form.Item>
                </Col>

                <Col sm={5} xs={8}>
                  <Form.Item label="Prefix" name="prefix">
                    <Select
                      placeholder="Select a Option"
                      defaultValue="Mr"
                      size="large"
                      options={[
                        { value: "Mr", label: "Mr" },
                        { value: "Ms", label: "Ms" },
                        { value: "Mrs", label: "Mrs" },
                      ]}
                    />
                  </Form.Item>
                </Col>

                <Col sm={19} xs={16}>
                  <Form.Item label="Full Name" name="full_name">
                    <Input size="large" placeholder="Enter your full name" />
                  </Form.Item>
                </Col>

                <Col sm={24} xs={24}>
                  <Form.Item name="phone_number">
                    <IntlPhoneInput
                      form={form}
                      name="phone_number"
                      required={false}
                      placeholder="Please Enter the phone number"
                      label="Phone Number"
                      defaultCountry={countryCode}
                    />
                  </Form.Item>
                </Col>

                <Col sm={24} xs={24}>
                  <Form.Item label="Email Address" name="email">
                    <Input size="large" placeholder="Enter your email" />
                  </Form.Item>
                </Col>

                <Col sm={12} xs={24}>
                  <Form.Item label="Country" name="country">
                    <Select
                      showSearch
                      size="large"
                      placeholder="Select a Country"
                      options={[
                        ...new Set(country.map((item) => item.name)),
                      ].map((ctr) => ({
                        value: ctr,
                        label: ctr,
                      }))}
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .includes(input.toLowerCase()) ||
                        option.value.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>

                <Col sm={12} xs={24}>
                  <Form.Item label="City" name="city">
                    <Input size="large" placeholder="Enter your City" />
                  </Form.Item>
                </Col>
              </Row>

              <Button
                type="default"
                htmlType="submit"
                className="submit-btn"
                block
                size="large"
                loading={loading.formLoading}
              >
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default InquieryForm;
